<template>
  <div class="itempage" style="background: #fff;">
    <el-card style="position: relative;padding-bottom: 10px;">
      <div style="font-size: 20px;font-weight: bold;color: #4b92ff;">{{ title_number }}</div>
      <div style="overflow: hidden;">
        <b style="float: left;">{{ title_subClass }} • </b>
        <span :title="title_description"
          style="display: inline-block;float: left;width: 30%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap">
          {{ title_description }}
        </span>
      </div>
      <!-- <div style="font-size: 16px;"><b>{{title_subClass}} • </b>{{title_description}}</div> -->
      <span class="title-current-style" :style="{ 'color': currentStatusColorType }">{{ title_currentStatus }}</span>
      <div style="margin-left: 20px;position: absolute;right: 22%;top: 3%;"></div>
    </el-card>

    <div style="margin-top: 10px;margin-left: 20px;">
      <el-button icon="el-icon-check" :disabled="hasARPriv" type="primary" plain size="small"
        @click="enableApproveWindow">
        {{ $t('message.title.approve') }}
      </el-button>
      <el-dialog v-dialogDrag :title="this.$t('message.title.approveRelease')" v-loading="btnLoading"
        :visible.sync="approveWindow">
        <div style="height:300px;position:relative;">
          <div class="table-list2">
            <span class="list-key">{{ $t('message.title.comments') }}</span>
            <span style="display: inline-block;margin: 0 6px;line-height:40px;float:left">:</span>
            <span class="list-val" style="float:left;">
              <el-input :style="input_width" :autosize="{ minRows: 9, maxRows: 12 }" type="textarea" :rows="2"
                :placeholder="$t('message.placeholder.input')" v-model="signoffComments">
              </el-input>
            </span>
          </div>
          <div class="table-list2 tableBtn">
            <el-button @click="approveChange">{{ $t('message.title.approve') }}</el-button>
            <el-button @click="approveWindow = false">{{ $t('message.button.cancel') }}</el-button>
          </div>

        </div>
      </el-dialog>
      <el-button style="margin: 0 10px;" icon="el-icon-close" :disabled="hasARPriv" size="small"
        @click="enableRejectWindow" type="danger" plain>{{ $t('message.title.reject') }}
      </el-button>
      <el-dialog v-dialogDrag :title="this.$t('message.title.rejectRelease')" v-loading="btnLoading"
        :visible.sync="rejectWindow">
        <div style="height:300px;position:relative;">
          <div class="table-list2">
            <span class="list-key">{{ $t('message.title.comments') }}</span>
            <span style="display: inline-block;margin: 0 6px;line-height:40px;float:left">:</span>
            <span class="list-val" style="float:left;">
              <el-input :style="input_width" :autosize="{ minRows: 9, maxRows: 12 }" type="textarea" :rows="2"
                :placeholder="$t('message.placeholder.input')" v-model="rejectComments">
              </el-input>
            </span>
          </div>
          <div class="table-list2 tableBtn">
            <el-button @click="rejectChange">{{ $t('message.title.reject') }}</el-button>
            <el-button @click="rejectWindow = false">{{ $t('message.button.cancel') }}</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- <el-button icon="el-icon-chat-round" size="small">{{$t('message.title.comments')}}</el-button> -->

      <el-button v-if="showNextStatusBtn" plain size="small" @click="showNextDialogVisible">
        {{ $t('message.title.manualNextStatus') }}
      </el-button>
      <el-dropdown v-else :class="StatusBtn ? 'next-status-btn' : ''" split-button @click="NextState" size="small"
        style="margin-left: 10px;;" @command="goToState">
        <span>
          {{ $t('message.title.manualNextStatus') }}
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="status in statusInfo" :key="status.id" :statusType="status.statusType"
            :command="status.id" :disabled="status.hasPriv == 0">{{ status.name }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dialog class="workflow-dialog" :visible.sync="nextDialogVisible" :modal-append-to-body="false"
        :show-close="false" width="800px">
        <div v-loading="loadingWorkFlow">
          <div class="workflow-box">
            <div class="workflow-title"> {{ $t('message.placeholder.selcet') }} </div>
            <div>{{ title_subClass }} • {{ title_number }}</div>
          </div>
          <div class="workflow-content">
            {{ $t('message.title.workflow') + ':' }}
            <el-select v-model="workFolw" :placeholder="$t('message.placeholder.search')">
              <el-option v-for="item in optionsWorkFlow" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <span slot="footer">
          <el-button @click="nextDialogVisible = false"> {{ $t('message.button.cancel') }}</el-button>
          <el-button type="primary" @click="next">{{ $t('message.button.next') }}</el-button>
        </span>
      </el-dialog>

      <!--<el-button icon="el-icon-document-delete" size="small" style="margin-left: 10px;">浏览器</el-button> -->
      <el-dropdown placement="bottom" style="margin-left: 10px">
        <el-button size="small">
          {{ $t('message.button.actions') }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item @click.native="creatNew = true"
              >{{$t('message.button.createChange')}}</el-dropdown-item
            > -->
          <!-- <el-dropdown-item @click.native = "cc">创建变更</el-dropdown-item> -->
          <el-dropdown-item @click.native="printPage">{{ $t('message.button.print') }}
          </el-dropdown-item>

          <el-dropdown-item @click.native="sendSaveItemToK3" v-if="thondarYON"
            v-show="!isDocRelease && (currentStatusType == 3 || currentStatusType == 4)">{{
              '发送物料' }}</el-dropdown-item>


          <el-dropdown-item @click.native="sendMaterialForm" v-if="thondarYON"
            v-show="!isDocRelease && (currentStatusType == 3 || currentStatusType == 4)">{{
              '发送物料清单' }}</el-dropdown-item>

          <el-dropdown-item @click.native="saveChangeBOMToK3" v-if="thondarYON"
            v-show="!isDocRelease && (currentStatusType == 3 || currentStatusType == 4)">{{
              '发送工程变更单' }}</el-dropdown-item>
          <el-dropdown-item @click.native="createXML" v-if="!thondarYON"
            v-show="!isDocRelease && (currentStatusType == 3 || currentStatusType == 4)" :disabled="!exportEnabled">{{
              $t('message.button.RegenerateXML') }}</el-dropdown-item>

          <el-dropdown-item @click.native="saveAs = true">{{ $t('message.button.saveAs') }}</el-dropdown-item>

          <el-dropdown-item @click.native="addFavorite">{{ $t('message.button.bookmark') }}</el-dropdown-item>
          <el-dropdown-item @click.native="removeFavorite">{{ $t('message.button.cancelBookmark') }}
          </el-dropdown-item>
          <el-dropdown-item :disabled="!deletePriv" @click.native="deleteItem">{{ $t('message.button.delete') }}
          </el-dropdown-item>
          <el-dropdown-item @click.native="exportItem">{{ $t('message.button.exportExcel') }}
          </el-dropdown-item>
          <!-- <el-dropdown-item :disabled="!deletePriv" @click.native="exportPDF">{{ 'PDF导出' }}
          </el-dropdown-item> -->
          <el-dropdown-item v-show="(currentStatusType == 3 || currentStatusType == 4)" :disabled="!rebackPriv"
            @click.native="statusReback">{{
              $t('message.button.restoreChange') }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- tab切换 -->
    <div class="content">

      <div class="content-title">
        <div @click="tabClick(item, index)" class="content-item" :class="{ active: index == num }"
          v-for="(item, index) in tabList" :key="index">
          <div style="display: flex;">
            <div>
              {{ item.name }}
            </div>
            <div :style="{ 'visibility': item.isResult ? 'visible' : 'hidden', }"
              style=" margin-left: 3px;font-size: 22px;">*</div>
          </div>
        </div>
      </div>

      <div style="height: 6px;background: #ebebeb;"></div>

      <div class="route-content">
        <div :key="getRoueteKey()">
          <router-view id="aa" :changeValue='change_to_child' :updateWorkflow='updateWorkflowTable' :relUrl='relUrl'
            :type='change' @routeClick='reload' @refreshTab="refreshTab"></router-view>
        </div>
      </div>



    </div>

    <el-dialog v-dialogDrag :title="$t('message.title.checkStatus')" :visible.sync="mandatoryField" width="42%"
      :before-close="auditClose" class="audit">
      <div v-show="audit_dialog">
        <div style="padding: 0 20px 10px 20px;">
          <div style="font-size: 20px;font-weight: bold;color: #000;">{{ $t('message.title.checkResult') }}
          </div>
          <div style="font-size: 16px;color: #000;"><b>{{ title_description }} • </b>{{ title_number }}</div>
        </div>
        <div style="font-size: 16px;background: #ffc8ca;padding: 10px 20px;color: #000;">
          <span style="position: relative;top: 2px;margin: 0 10px 0 0;">
            <img src="@/assets/change/warning.png" alt="">
          </span>
          <!-- 存在下列问题。必须先解决所有错误，然后状态才能变更为 {{nextStatusText}}。如果只存在警告，则可以继续。 -->
          {{ $t('message.tips.workflow_101') + nextStatusText + $t('message.tips.workflow_102') }}
        </div>
        <div style="padding: 10px 20px 0 20px;" v-if="audit_dialog_error">
          <span style="font-size: 20px;color: #000;">{{ $t('message.title.error') }}:</span>
          <ul style="list-style: disc;padding-top: 0;">
            <li v-for="item in audit_erro" style="color: red;font-size: 16px;" :key="item.index">
              {{ item.msg }}</li>
          </ul>
        </div>
        <div style="padding: 0 20px 0 20px;" v-if="audit_dialog_warning">
          <span style="font-size: 20px;color: #000;">{{ $t('message.title.warning') }}:</span>
          <ul style="list-style: disc;padding-top: 0;">
            <li v-for="item in audit_warning" style="color: #f7a420;font-size: 16px;" :key="item.index">
              {{ item.msg }}</li>
          </ul>
        </div>
      </div>

      <div v-show="audit_add">
        <div style="padding: 0 20px 10px 20px;">
          <div style="font-size: 20px;font-weight: bold;color: #000;">
            {{ $t('message.title.changeStatusTo') + nextStatusText }}</div>
          <div style="font-size: 16px;color: #000;"><b>{{ title_description }} • </b>{{ title_number }}</div>
        </div>
        <div style="font-size: 16px;background: #d4e8fd;padding: 10px 20px;color: #000;">
          <span style="position: relative;top: 4px;margin: 0 10px 0 0;">
            <img src="@/assets/change/info.png" alt="">
          </span>
          {{ $t('message.tips.workflow_103') }}
        </div>

        <div class="table-list2" style="margin-top: 20px;">
          <span class="list-key">{{ $t('message.title.approver') }}</span>
          <span style="margin: 0 6px;line-height:40px;float:left">:</span>
          <span class="list-val" style="float:left;" :style="input_width2">
            <el-select :disabled="!addApproverPriv" size="small" :style="input_width" v-model="approvers" multiple
              filterable remote @change="change1" :placeholder="$t('message.placeholder.input')"
              :remote-method="remoteMethod" :loading="loading">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </span>
          <el-button :disabled="!addApproverPriv" type="primary" style="float:left;" size="small"
            @click="openSearchApproverWindow">
            {{ $t('message.button.search') }}</el-button>
        </div>

        <div class="table-list2">
          <span class="list-key">{{ $t('message.title.observer') }}</span>
          <span style="margin: 0 6px;line-height:40px;float:left">:</span>
          <span class="list-val" style="float:left;" :style="input_width2">
            <el-select :disabled="!addApproverPriv" size="small" :style="input_width" v-model="notify" multiple
              filterable remote @change="change2" :placeholder="$t('message.placeholder.input')"
              :remote-method="remoteMethod2" :loading="loading">
              <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </span>
          <el-button :disabled="!addApproverPriv" type="primary" style="float:left;" size="small"
            @click="openNotifyWindow">
            {{ $t('message.button.search') }}</el-button>
        </div>

        <div class="table-list2" style="margin-bottom: 20px;">
          <span class="list-key">{{ $t('message.title.comments') }}</span>
          <span style="display: inline-block;margin: 0 6px;line-height:40px;float:left">:</span>
          <span class="list-val" style="float:left;">
            <el-input :style="input_width3" :autosize="{ minRows: 4, maxRows: 6 }" type="textarea" :rows="2"
              :placeholder="$t('message.placeholder.input')" v-model="textarea">
            </el-input>
          </span>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div v-if="audit_dialog">
          <el-button type="primary" @click="NextState">{{ $t('message.title.check') }}</el-button>
          <el-button type="success" @click="nextStatusBtnClick" :disabled="nextStatusBtn">
            {{ $t('message.button.next') }}</el-button>
          <el-button @click="mandatoryField = false; audit_add = false">{{ $t('message.button.cancel') }}
          </el-button>
        </div>

        <div v-if="audit_add">
          <el-button type="success" @click="submitAudit">{{ $t('message.title.finish') }}</el-button>
          <el-button @click="mandatoryField = false; audit_add = false">{{ $t('message.button.cancel') }}
          </el-button>
        </div>
      </span>

    </el-dialog>

    <el-dialog v-dialogDrag v-if="saveAs" class="searchAddBomList" :title="$t('message.title.saveAs')"
      :visible.sync="saveAs" :close-on-click-modal="!saveAs">
      <!-- <searchAdd @listDbClick="addList"></searchAdd> -->
      <save-as-form @close="cancelSaveAs"></save-as-form>
    </el-dialog>

    <el-dialog v-dialogDrag v-if="reviewersAddList" class="reviewersAddDialog" :title="$t('message.title.addApprover')"
      :visible.sync="reviewersAddList" :before-close="reviewersHandleClose">
      <searchAddUsers :userGroupLists1="userGroupLists" :projectWorkflowSubClassId="projectWorkflowSubClassId"
        @listDbClick="addApprover"></searchAddUsers>
    </el-dialog>

    <el-dialog v-dialogDrag v-if="notifyAddList" class="notifyAddDialog" :title="$t('message.title.addObserver')"
      :visible.sync="notifyAddList" :before-close="notifyHandleClose">
      <searchAddUsers :userGroupLists1="userGroupLists" :projectWorkflowSubClassId="projectWorkflowSubClassId"
        @listDbClick="addObserver"></searchAddUsers>
    </el-dialog>
  </div>
</template>


<script>
import searchAddUsers from "@/components/searchAddUsers.vue";
import SaveAsForm from '../common/saveAsFormForCommon.vue';
import axios from "axios";
import { changeTabList } from "@/utils/publicstate";
import { dialogDrag } from '@/utils/directive'
import { getTabIndex } from "@/utils/index.js"

import Vue from "vue";
Vue.directive('dialogDrag', dialogDrag);
export default {
  name: 'changePage',
  data() {
    return {
      showNextStatusBtn: false,
      checkStatusInfo: null,
      loadingWorkFlow: false,
      currentStatusColorType: '#cc3333',
      userGroupLists: "",
      isStatusChange: true, //statusChange失败不继续往下走
      StatusBtn: false, //下个状态按钮是否可点击
      nextDialogVisible: false,
      list: [],
      textarea: "",
      reviewersAddList: false, //添加窗口开关
      notifyAddList: false, //添加窗口开关
      relUrl: "changes",
      change: "change",
      workFolw: null,
      optionsWorkFlow: [],
      options: [],
      options2: [],
      approvers: [],
      notify: [],
      nextStatusBtn: true,
      audit_add: false,
      audit_dialog_error: false,
      audit_dialog_warning: false,
      fullscreenLoading: false,
      audit_dialog: false,
      audit_warning: [
        {
          msg: "WARNING1",
        },
        {
          msg: "WARNING2",
        },
        {
          msg: "WARNING3",
        },
      ],
      audit_erro: [
        {
          msg: "ERROR1",
        },
        {
          msg: "ERROR2",
        },
        {
          msg: "ERROR3",
        },
      ],
      showNext: true,
      mandatoryField: false, //变更必填字段
      updateWrokflowNum: 1,
      input_width: {
        width: "96%",
      },
      input_width2: {
        width: "50%",
      },
      input_width3: {
        width: "80%",
      },

      statusInfo: [], //状态信息
      status: 0, //当前状态
      workflowId: "", //当前工作流

      changeInfo_All: [], //change的所有信息
      change_value: "0", //change选中的信息
      change_to_child: "", //向子组件传送change信息
      updateWorkflowTable: "", //向子组件传送change信息
      hasSaveChange: false,

      title_number: "",
      title_subClass: "",
      title_description: "",
      title_currentStatus: "",
      title_currentStatusId: "",
      title_currentStatusType: "",
      title_nextStatusId: "",
      title_nextStatusType: "",
      title_workflowId: "",
      nextStatusText: "",
      nextStatusTextVal: "",
      page_one: [],
      tabList: [],
      loading: true,
      deletePriv: false,
      addApproverPriv: false,//审查者添加权限
      version: "",
      userInfo: {},
      approveWindow: false,
      rejectWindow: false,
      signoffComments: "",
      rejectComments: "",
      currentUserId: "",
      currentUserLoginId: "",
      tabItem: null,
      routeLink: Boolean,
      base: "",

      currentStatusType: 0,
      exportEnabled: false,
      isDocRelease: false,

      saveAs: false,

      hasARPriv: true,
      projectWorkflowSubClassId: "",
      thondarYON: false,
      btnLoading: false,
      objInfo: { ...this.$route.query }
    };
  },
  computed: {
    num() {
      return this.tabList.findIndex(i => i.path == this.$route.path)
    }
  },
  methods: {
    statusReback() {
      axios.get(`pmdm/changes/returnChangeStatus?changeId=` + this.$store.state.objectId.id).then(res => {
        if (res.data.code === 200) {
          this.reload()
        }
      })
    },
    getRoueteKey() {
      const { id, classId, subClassId } = this.objInfo
      const str = [id, classId, subClassId, this.title_currentStatus].join('_');
      return str
    },
    printPage() {
      // window.print()
      let newstr = document.getElementById("aa").innerHTML;
      let oldstr = document.body.innerHTML;
      document.body.innerHTML = newstr;
      window.print();
      document.body.innerHTML = oldstr;

      this.$nextTick(() => {
        window.location.reload();
      })

    },
    showNextDialogVisible() {
      this.nextDialogVisible = true;
      this.showNext = true;
    },
    getWorkflow() {
      const query = this.$route.query;
      let params = {//获取workflow
        subclassId: query.subClassId
      };
      axios.get(`/pmdm/admin/workflow/getWorkflowBySubclass${this.params(params)}`).then(res => {
        this.optionsWorkFlow = res.data.object;
      })
    },
    async next() {
      const vm = this;
      if (!this.workFolw) {
        this.$message.error('请先选择一个工作流');
        return;
      }
      this.loadingWorkFlow = true;
      const query = this.$route.query;
      const objectIds = {//获取workflow
        "id": Number(query.id),
        "classId": Number(query.classId),
        "subClassId": Number(query.subClassId)
      };
      const params = {
        "pageOne": { "1004008": String(this.workFolw) },
        "pageTwo": {},
        "pageThree": {},
        "objectId": objectIds,
        "changeId": {}
      }
      const res = await axios.post('/pmdm/changes/updateChangeP1P2P3', params);
      if (res.data.code === 200) {
        var obj_get = {
          //获取change
          ... this.$store.state.objectId,
          tableId: 1,
        };
        var loadTableUrl = `/pmdm/changes/loadTable${this.params(obj_get)}`;
        const {
          //获取标题
          data: res1,
        } = await this.$http.get(loadTableUrl);
        this.page_one = this.getNewData(res1.object.table.columnInfo);
        var val_ = res1.object.table.rows[0].cells;
        for (var i = 0; i < this.page_one.length; i++) {
          this.page_one[i].val = val_[i];
          if (this.page_one[i].id == 1004001) {
            this.title_number = this.page_one[i].val.val;
          }
          if (this.page_one[i].id == 1004002) {
            this.title_currentStatus = this.page_one[i].val.val;
            this.title_currentStatusId = this.page_one[i].val.id;
          }
          if (this.page_one[i].id == 1004005) {
            this.title_description = this.page_one[i].val.val;
          }
          if (this.page_one[i].id == 1004008) {
            this.showNextStatusBtn = this.page_one[i].val.id == -1;
          }
        }
        var statusId = this.title_currentStatusId;
        if (statusId === "") statusId = -1;
        var getNextAllStatus = {
          //获取change
          statusId: statusId,
          subClassId: this.$store.state.objectId.subClassId,
        };
        const getAllStatusUrl = `/pmdm/admin/workflow/getNextStatus${this.params(
          getNextAllStatus
        )}`;
        const { data: res2 } = await this.$http.get(getAllStatusUrl);
        if (res2.object.nextStatus.length !== 0) {
          this.statusInfo = res2.object.nextStatus;
          this.title_currentStatusType = res2.object.currentWorkflowStatus.statusType;
          this.title_nextStatusId = res2.object.nextWorkflowStatus.id;
          this.title_nextStatusType = this.deepClone(
            res2.object.nextWorkflowStatusType
          );
          this.nextStatusType_old = this.deepClone(
            res2.object.nextWorkflowStatusType
          );
          this.nextStatusTextVal = res2.object.nextStatus[0].name;
          this.nextStatusText = res2.object.nextStatus[0].name;
        }
        const change_info = this.$store.state.change_info;
        const checkStatusParams = {
          ...objectIds,
          version: this.version,
          currentStatus: Number(this.title_currentStatusId),
          currentStatusType: this.title_currentStatusType,
          nextStatus: this.title_nextStatusId,
          nextStatusType: this.title_nextStatusType,
          workflowId: Number(this.workFolw),
          changeId: change_info.changeId,
          changeClassId: change_info.changeClassId,
          changeSubClassId: change_info.changeSubClassId,
        }

        const checkStatus = await axios
          .post("/pmdm/changes/checkStatus", checkStatusParams);
        this.checkStatusInfo = checkStatus.data.object;

        if (this.tabItem.id === 1010401) {
          const query = { ...this.$store.state.objectId, refresh: Date.now() };
          const tab = this.tabList[0];
          this.$router.push({ path: tab.path, query });
        }
        this.logoInfo();
        if (this.title_nextStatusType > 0) {
          this.StatusBtn = false;
          const vm = this;
          setTimeout(() => {
            vm.title_workflowId = vm.workFolw;
            vm.NextState();
          }, 200);
        } else {
          this.showNext = false;
        }
        this.loadingWorkFlow = false;
        this.nextDialogVisible = false;
      }

    },
    sendSaveItemToK3() {
      const obj = { ... this.$store.state.objectId }
      axios.post(`/pmdm/changes/saveItemToK3${this.params(obj)}`).then(res => {
        this.$message.success(res.data.message);
        this.hasSaveChange = true;
      })
    },
    sendMaterialForm() {
      const obj = { ... this.$store.state.objectId }
      axios.post(`/pmdm/changes/saveBOMToK3${this.params(obj)}`).then(res => {
        this.$message.success(res.data.message);
        this.hasSaveChange = true;
      })
    },

    saveChangeBOMToK3() {

      const obj = { ... this.$store.state.objectId }
      axios.post(`/pmdm/changes/saveChangeBOMToK3${this.params(obj)}`).then(res => {
        this.$message.success(res.data.message)
      })
    },

    cancelSaveAs() {
      this.saveAs = false
    },
    change1() {
      this.options = [];
    },
    change2() {
      this.options2 = [];
    },
    removeFavorite() {
      // console.log("removeFavorite");
      this.removeFavoriteInCommon({
        baseClassId: this.Constants.changeBaseClassId,
        number: this.title_number,
        ... this.$store.state.objectId,
        //id: this.$store.state.objId_,
      });
    },
    reload(e) {
      if (e == undefined) {
        this.logoInfo();
        return;
      }

      const obj = {
        id: e.itemId,
        classId: e.itemClassId,
        subClassId: e.itemSubClassId,
        title: e[0]
      };
      this.getLink(obj);
    },
    deleteItem() {
      this.$confirm(
        this.$t("message.confirm.deleteObject"),
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let obj = {
            ... this.$store.state.objectId,
          };
          axios
            .get(`/pmdm/changes/deleteChangeP1${this.params(obj)}`)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.success(res.data.message);
                this.$emit("deletePage", this.title_number);
              } else {
                this.$message({
                  type: "info",
                  message: this.$t("message.error.delete"),
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.tips.deleteCancel"),
          });
        });
    },
    exportPDF() {
      const itemIds = this.$store.state.records;
      // console.log(itemIds);
      // return
      let obj = {
        ...this.$store.state.objectId,
        changeSubClassId: this.$store.state.objectId.subClassId,
        changeId: this.$store.state.objectId.id,
        changeClassId: this.$store.state.objectId.classId,
        tableId: 201,
        itemIds
      };
      console.log(obj);

      axios({
        method: "get",
        url: `/pmdm/change/exportPDF${this.params(obj)}`,
        responseType: "blob",
      }).then((res) => {
        let blob = new Blob([res.data], {
          type: "application/x-msdownload;charset=utf-8",
        }); // 文件类型
        console.log(res.headers["content-disposition"]); // 从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment;filename=" + fileName + ".xlsx") 设置的文件名;
        //以=分割取数组[1]元素为文件名
        let filename = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        let url = window.URL.createObjectURL(blob); // 创建下载链接
        let aLink = document.createElement("a"); // 赋值给a标签的href属性
        aLink.style.display = "none";
        aLink.href = url;
        aLink.setAttribute("download", filename + '.zip');
        document.body.appendChild(aLink); // 将a标签挂载上去
        aLink.click(); // a标签click事件
        document.body.removeChild(aLink); // 移除a标签
        window.URL.revokeObjectURL(url);
      });
    },

    exportItem() {
      let obj = {
        ...this.$store.state.objectId,
        changeSubClassId: this.$store.state.objectId.subClassId,
        changeId: this.$store.state.objectId.id,
        changeClassId: this.$store.state.objectId.classId,
        tableId: 201
      };
      console.log(obj);

      axios({
        method: "get",
        url: `/pmdm/change/exportExcel${this.params(obj)}`,
        responseType: "blob",
      }).then((res) => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8",
        }); // 文件类型
        console.log(res.headers["content-disposition"]); // 从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment;filename=" + fileName + ".xlsx") 设置的文件名;
        //以=分割取数组[1]元素为文件名
        let filename = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        let url = window.URL.createObjectURL(blob); // 创建下载链接
        let aLink = document.createElement("a"); // 赋值给a标签的href属性
        aLink.style.display = "none";
        aLink.href = url;
        aLink.setAttribute("download", filename);
        document.body.appendChild(aLink); // 将a标签挂载上去
        aLink.click(); // a标签click事件
        document.body.removeChild(aLink); // 移除a标签
        window.URL.revokeObjectURL(url);
      });
    },

    createXML() {
      let obj = {
        ...this.$store.state.objectId,
        changeSubClassId: this.$store.state.objectId.subClassId,
        changeId: this.$store.state.objectId.id,
        changeClassId: this.$store.state.objectId.classId,
      };
      axios.get(`/pmdm/change/exportXML${this.params(obj)}`).then((res) => {
        console.log(res);
        // this.exportEnabled = res.data.object;
      });
    },
    addFavorite() {
      console.log("addFavorite");
      let description_ = "";
      if (this.title_description) {
        description_ = ":" + this.title_description;
      }
      this.addFavoriteInCommon({
        baseClassId: this.Constants.changeBaseClassId,
        number: this.title_number + description_,
        ... this.$store.state.objectId,
        //id: this.$store.state.objId_,
      });
    },
    submitAudit() {
      this.addReviewers();
    },
    addApprover(row) {
      //添加
      if (row) {
        //console.log(this.approvers.length);
        //console.log(row);
        var isDuplicateVal = false;
        for (var j = 0; j < this.approvers.length; j++) {
          //console.log(this.approvers[j]);
          if (row.itemId == this.approvers[j]) {
            isDuplicateVal = true;
            break;
          }
        }
        if (isDuplicateVal) {
          this.$message.error(this.$t("message.error.sameUser"));
        } else {
          // this.reviewersAddList = false;
          let user = {};
          user.value = row.itemId;
          for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].value == row.itemId) {
              user.label = this.list[i].label;
            }
          }
          this.options.push(user);
          this.approvers.push(row.itemId);
          this.$message.success('添加成功')
        }
      }
    },
    addObserver(row) {
      //添加
      if (row) {
        //console.log(this.notify.length);
        //console.log(row);
        var isDuplicateVal = false;
        for (var j = 0; j < this.notify.length; j++) {
          if (row.itemId == this.notify[j]) {
            isDuplicateVal = true;
            break;
          }
        }
        if (isDuplicateVal) {
          this.$message.error(this.$t("message.error.sameUser"));
        } else {
          // this.notifyAddList = false;
          let user = {};
          user.value = row.itemId;
          for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].value == row.itemId) {
              user.label = this.list[i].label;
            }
          }
          this.options2.push(user);
          this.notify.push(row.itemId);
          this.$message.success('添加成功')
        }
      }
    },
    reviewersHandleClose() {
      this.reviewersAddList = false;
    },
    notifyHandleClose() {
      this.notifyAddList = false;
    },
    openSearchApproverWindow() {
      this.reviewersAddList = true;
    },
    openNotifyWindow() {
      this.notifyAddList = true;
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    remoteMethod2(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options2 = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options2 = [];
      }
    },
    enableApproveWindow() {
      var approversInRequest = [];
      let user = {};
      user.id = this.currentUserId;
      user.loginId = this.currentUserLoginId;
      user.type = 1;
      approversInRequest.push(user);

      var checkChangeRequest = {
        //post更改的值
        objectId: {
          ... this.$store.state.objectId,
          // version:this.version
        },
        status: Number(this.title_currentStatusId),
        user: approversInRequest,
      };
      //console.log(approveChangeRequest);
      var vm = this;
      axios
        .post("/pmdm/changes/checkApproveRejectUser", checkChangeRequest)
        .then(function (res) {
          console.log(res);
          if (res.data.object.code == 200) {
            vm.approveWindow = true;
            vm.signoffComments = "";
          } else {
            vm.$confirm(res.data.object.message, vm.$t("message.tips.tip"), {
              confirmButtonText: vm.$t("message.button.affirm"),
              cancelButtonText: vm.$t("message.button.cancel"),
              type: "warning",
            })
              .then(() => {
                vm.approveWindow = true;
                vm.signoffComments = "";
              })
              .catch(() => {
                vm.$message({
                  type: "info",
                  message: vm.$t("message.tips.cancel"),
                });
              });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    approveChange() {
      var approversInRequest = [];
      let user = {};
      user.id = this.currentUserId;
      user.loginId = this.currentUserLoginId;
      user.type = 1;
      approversInRequest.push(user);

      this.btnLoading = true

      var approveChangeRequest = {
        //post更改的值
        objectId: {
          ... this.$store.state.objectId,
          // version:this.version
        },
        status: Number(this.title_currentStatusId),
        approvers: approversInRequest,
        comments: this.signoffComments,
      };
      //console.log(approveChangeRequest);
      var vm = this;
      axios.post("/pmdm/changes/approveChange", approveChangeRequest).then(function (res) {
        if (res.data.code == 200) {
          vm.approveWindow = false;
          vm.$message({
            message: res.data.message,
            type: "success",
          });
          vm.updateWrokflowNum += 1;
          vm.updateWorkflowTable = vm.updateWrokflowNum;

          //vm.change_to_child = res.data.object.approveStatusId;
          vm.logoInfo();
        }
      }).catch(function (error) {
        vm.$message.error(this.$t("message.error.approve"));
        console.log(error);
        vm.approveWindow = false;
      }).finally(_ => {
        this.btnLoading = false
      })
    },
    enableRejectWindow() {
      var approversInRequest = [];
      let user = {};
      user.id = this.currentUserId;
      user.loginId = this.currentUserLoginId;
      user.type = 1;
      approversInRequest.push(user);

      this.btnLoading = true

      var checkChangeRequest = {
        //post更改的值
        objectId: {
          ... this.$store.state.objectId,
          // version:this.version
        },
        status: Number(this.title_currentStatusId),
        user: approversInRequest,
      };
      //console.log(approveChangeRequest);
      var vm = this;
      axios
        .post("/pmdm/changes/checkApproveRejectUser", checkChangeRequest)
        .then(function (res) {
          console.log(res);
          if (res.data.object.code == 200) {
            vm.rejectWindow = true;
            vm.rejectComments = "";
          } else {
            vm.$confirm(res.data.object.message, vm.$t("message.tips.tip"), {
              confirmButtonText: vm.$t("message.button.affirm"),
              cancelButtonText: vm.$t("message.button.cancel"),
              type: "warning",
            })
              .then(() => {
                vm.rejectWindow = true;
                vm.rejectComments = "";
              })
              .catch(() => {
                vm.$message({
                  type: "info",
                  message: vm.$t("message.tips.cancel"),
                });
              });
          }
        })
        .catch(function (error) {
          console.log(error);
        }).finally(_ => {
          this.btnLoading = false
        });
    },
    rejectChange() {
      var rejectersInRequest = [];
      let user = {};
      user.id = this.currentUserId;
      user.loginId = this.currentUserLoginId;
      user.type = 1;
      rejectersInRequest.push(user);
      this.rejectComments = this.rejectComments.trim();
      if (this.rejectComments == "") {
        this.$message({
          message: this.$t("message.error.rejectNoComments"),
          type: "error",
        });
        return false;
      }

      var rejectChangeRequest = {
        //post更改的值
        objectId: {
          ... this.$store.state.objectId,
          // version:this.version
        },
        status: Number(this.title_currentStatusId),
        rejecters: rejectersInRequest,
        comments: this.rejectComments,
      };
      //console.log(rejectChangeRequest);
      var vm = this;
      axios
        .post("/pmdm/changes/rejectChange", rejectChangeRequest)
        .then(function (res) {
          if (res.data.code == 200) {
            vm.rejectWindow = false;
            vm.$message({
              message: res.data.message,
              type: "error",
            });
            vm.updateWrokflowNum += 1;
            vm.updateWorkflowTable = vm.updateWrokflowNum;
            vm.change_to_child = res.data.object.rejectStatusId;
          } else {
            vm.$message.error(this.$t("message.error.reject"));
            console.log(error);
            vm.rejectWindow = false;
          }
          vm.logoInfo();
        });
      // .catch(function (error) {
      // 	vm.$message.error("驳回失败。");
      // 	console.log(error);
      // 	vm.rejectWindow = false;
      // });

    },
    updateChildData(msg) {
      if (msg) {
        this.logoInfo();
      }
    },
    NextState() {
      //console.log(this.statusInfo);
      //this.goToState(this.statusInfo[0].id);
      if (this.StatusBtn) {
        return false;
      } else {
        //this.fullscreenLoading = true;
        this.textarea = "";
        this.nextStatusText = this.nextStatusTextVal;
        this.title_nextStatusType = this.nextStatusType_old;
        this.getAudit();
      }
    },
    getAudit() {
      var vm = this;
      const loading = this.$loading({
        lock: true,
        text: "正在验证状态，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var change_info = this.$store.state.change_info;
      console.log(this.title_nextStatusType);
      axios
        .post("/pmdm/changes/checkStatus", {
          //
          ... this.$store.state.objectId,
          version: this.version,
          currentStatus: Number(this.title_currentStatusId),
          currentStatusType: this.title_currentStatusType,
          nextStatus: this.title_nextStatusId,
          nextStatusType: this.title_nextStatusType,
          workflowId: Number(this.title_workflowId),
          changeId: change_info.changeId,
          changeClassId: change_info.changeClassId,
          changeSubClassId: change_info.changeSubClassId,
        })
        .then(function (res) {
          //console.log(res);
          if (res.data.object.codeId == 20004) {
            loading.close();
            //this.audit_dialog = true;
            vm.audit_dialog = true;
            //vm.fullscreenLoading = false;
            vm.mandatoryField = true;
            //console.log(res.data.object.error);
            if (res.data.object.error.length !== 0) {
              vm.audit_dialog_error = true;
              vm.audit_add = false;
              vm.audit_erro = res.data.object.error;
              vm.nextStatusBtn = true;
            } else {
              vm.audit_dialog_error = false;
              vm.nextStatusBtn = false;
            }
            if (res.data.object.warning.length !== 0) {
              vm.audit_dialog_warning = true;
              vm.audit_warning = res.data.object.warning;
              // vm.nextStatusBtn = false;
            } else {
              vm.audit_dialog_warning = false;
            }
            vm.updateUsers();
            vm.loadUser();
          }
          if (res.data.object.codeId == 200) {
            //console.log(vm.title_nextStatusType);
            //vm.fullscreenLoading = false;
            loading.close();
            if (vm.title_nextStatusType == 2 || vm.title_nextStatusType == 3) {
              vm.audit_dialog = false;
              vm.mandatoryField = true;
              vm.audit_add = true;
              vm.updateUsers();
              vm.loadUser();
            } else {
              //vm.$refs.submitClick.click();
              vm.submitAudit();
            }
          }
        })
        .catch(function (error) {
          console.log(error);
          loading.close();
        });
    },
    refreshTab() {
      this.$getTabsIsUsedResult(this.tabIdLists).then(
        res => {
          this.tabList.map(item => {
            const isTrue = res.includes(item.id)
            this.$set(item, 'isResult', isTrue);
          });
        }
      );
    },
    async loadUser() {
      this.approvers = [];
      this.notify = [];
      this.options = [];
      this.options2 = [];
      let vm = this;

      var getSignoffByStatus = {
        ...this.$store.state.objectId,
        changeId: this.$store.state.objectId.id,
        //changeId: this.$store.state.objId_,
        statusId: this.title_nextStatusId,
      };
      const getSignoffUser = `/pmdm/admin/workflow/getSignoffByStatus${this.params(
        getSignoffByStatus
      )}`;
      const { data: res } = await this.$http.get(getSignoffUser);
      //console.log(res);
      if (res.code == 200) {
        let approveUsers = res.object.approveUserList;
        this.textarea = res.object.comments;
        // for (let i = 0; i < approveUsers.length; i++) {
        //   vm.approvers.push(approveUsers[i].id);
        //   let obj = {};
        //   obj.value = approveUsers[i].id;
        //   obj.label =
        //     approveUsers[i].loginId +
        //     "(" +
        //     approveUsers[i].userName +
        //     "      " +
        //     ")";
        //   vm.options.push(obj);
        // }
        approveUsers.forEach(user => {
          // 校验 userName 是否存在，不存在则显示空字符串
          const userName = user.userName || '';
          vm.approvers.push(user.id);
          vm.options.push({
            value: user.id,
            label: `${user.loginId}(${userName})`
          });
        });
        let observerUsers = res.object.observerUserList;
        // for (let i = 0; i < observerUsers.length; i++) {
        //   vm.notify.push(observerUsers[i].id);
        //   let obj = {};
        //   obj.value = observerUsers[i].id;
        //   obj.label =
        //     observerUsers[i].loginId +
        //     "(" +
        //     observerUsers[i].userName +
        //     "      " +
        //     ")";
        //   vm.options2.push(obj);
        // }
        observerUsers.forEach(user => {
          // 校验 userName 是否存在，不存在则显示空字符串
          const userName = user.userName || '';
          vm.notify.push(user.id);
          vm.options2.push({
            value: user.id,
            label: `${user.loginId}(${userName})`
          });
        });
      }
    },
    auditClose() {
      this.mandatoryField = false;
      this.audit_add = false;
    },
    async statusChange(signoffInfo) {
      var vm = this;
      //vm.addReviewers();
      await axios
        .post("/pmdm/changes/statusChange", {
          //
          ... this.$store.state.objectId,
          version: this.version,
          currentStatus: Number(this.title_currentStatusId),
          currentStatusType: this.title_currentStatusType,
          nextStatus: this.title_nextStatusId,
          nextStatusType: this.title_nextStatusType,
          workflowId: Number(this.title_workflowId),

          status: Number(this.title_nextStatusId),
          approvers: signoffInfo ? signoffInfo.approvers : [],
          observers: signoffInfo ? signoffInfo.observers : [],
          comments: this.textarea,
        })
        .then(function (res) {
          console.log(res);
          if (res.data.code == 200) {
            vm.$message({
              message: res.data.message,
              type: "success",
            });
            //vm.$emit('ChildIsUpdata', vm.childIsUpdata);
            vm.loading = false;
            vm.logoInfo();

            // if (vm.title_nextStatusType == 3 || vm.title_nextStatusType == 4) {
            //   vm.createXML();
            // }
            //vm.created_1 = !vm.created_1;
            //vm.change_to_child = vm.title_nextStatusId;
            vm.isStatusChange = true;
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.isStatusChange = false;
        });
    },
    async addReviewers() {
      // let tempApprovers = this.reOrganizeSignoffUser(this.approvers);
      // let tempObservers = this.reOrganizeSignoffUser(this.notify);

      // console.log(tempApprovers);
      // var approversInRequest = [];
      // for(var i = 0; i< tempApprovers.length; i++) {
      // 	let user = {};
      // 	user.id = tempApprovers[i];
      // 	user.loginId = this.getUserLoginId(tempApprovers[i]);
      // 	user.type = "1";
      // 	approversInRequest.push(user);
      // };

      // var observersInRequest = [];
      // for(var i = 0; i< tempObservers.length; i++) {
      // 	let user = {};
      // 	user.id = tempObservers[i];
      // 	user.loginId = this.getUserLoginId(tempObservers[i]);
      // 	user.type = "2";
      // 	observersInRequest.push(user);
      // };
      var approversInRequest = [];
      for (var i = 0; i < this.approvers.length; i++) {
        let user = {};
        user.id = this.approvers[i];
        for (var j = 0; j < this.list.length; j++) {
          if (this.approvers[i] == this.list[j].value) {
            user.loginId = this.list[j].label.replace(/\([^\)]*\)/g, "");
          }
        }
        //user.loginId = this.getUserLoginId(tempApprovers[i]);
        user.type = "1";
        approversInRequest.push(user);
      }

      var observersInRequest = [];
      for (var i = 0; i < this.notify.length; i++) {
        let user = {};
        user.id = this.notify[i];
        for (var j = 0; j < this.list.length; j++) {
          if (this.notify[i] == this.list[j].value) {
            user.loginId = this.list[j].label.replace(/\([^\)]*\)/g, "");
          }
        }
        user.type = "2";
        observersInRequest.push(user);
      }

      for (var m = 0; m < approversInRequest.length; m++) {
        for (var n = 0; n < observersInRequest.length; n++) {
          if (approversInRequest[m].id == observersInRequest[n].id) {
            this.$message.error(this.MessageInfo.e_203);
            return false;
          }
        }
      }

      var updateSignoffRequest = {
        //post更改的值
        objectId: {
          ... this.$store.state.objectId,
          // version:this.version
        },
        status: Number(this.title_nextStatusId),
        approvers: approversInRequest,
        observers: observersInRequest,
        comments: this.textarea,
      };
      console.log(updateSignoffRequest);
      var vm = this;

      let nextStatusList = this.title_nextStatusId;
      let isHold = 1;
      //console.log(this.statusInfo);
      for (var j = 0; j < this.statusInfo.length; j++) {
        if (this.statusInfo[j].id == nextStatusList) {
          isHold = this.statusInfo[j].statusType;
        }
      }
      //console.log(isHold);
      if (
        this.title_nextStatusType == 2 ||
        this.title_nextStatusType == 3 ||
        isHold == 2 ||
        isHold == 3
      ) {
        await vm.statusChange(updateSignoffRequest);
        if (vm.isStatusChange) {
          // axios
          //   .post("/pmdm/changes/updateSignoff", updateSignoffRequest)
          //   .then(function (res) {
          //     if (res.data.code == 200) {
          //vm.loadWorkflowHistory();
          //vm.outerVisible = false;
          //vm.deleteSignoffUser = false;\
          //console.log(res);

          // vm.$message({
          // 	message: res.data.message,
          // 	type: 'success'
          // });
          vm.updateWrokflowNum += 1;
          vm.updateWorkflowTable = vm.updateWrokflowNum;
          vm.mandatoryField = false;
          vm.audit_add = false;
          vm.logoInfo();
          //   }
          // })
          // .catch(function (error) {
          //   vm.$message.error(this.$t("message.error.change"));
          //   console.log(error);
          //   vm.outerVisible = false;
          // });
        }
      } else {
        vm.statusChange();
      }
      vm.mandatoryField = false;
    },
    reOrganizeSignoffUser(signoffUsers) {
      let tempUsers = [];
      //console.log(signoffUsers.length);
      for (var i = 0; i < signoffUsers.length; i++) {
        if (this.getUserLoginId(signoffUsers[i]) == undefined) {
          tempUsers.push(this.getUserId(signoffUsers[i]));
        } else {
          //console.log(signoffUsers[i]);
          tempUsers.push(signoffUsers[i]);
        }
      }
      //console.log(tempApprovers);
      return tempUsers;
    },
    async updateUsers() {
      let subclassId = this.$store.state.objectId.subClassId;
      this.list = [];
      var loadTableUrl = `/pmdm/admin/user/getApproveUserList?privType=16` + "&subclassId=" + subclassId;
      const {
        //获取标题
        data: res,
      } = await this.$http.get(loadTableUrl);
      //console.log(res.object.table.rows);
      //console.log(res.object.table.rows[0].objId);
      //console.log(res.object.table.rows[0].cells[0].val);
      let rows = res.object.users;
      for (var i = 0; i < rows.length; i++) {
        let user = {};
        user.value = rows[i].id;
        user.label = rows[i].loginId + "(" + rows[i].userName + "      " + ")";
        if (rows[i].authTag == 1) {
          user.disabled = false;
        } else {
          user.disabled = true;
        }
        this.list.push(user);
      }

      let groupRows = res.object.userGroups;
      this.userGroupLists = [];
      for (var i = 0; i < groupRows.length; i++) {
        let userGroup = {};
        userGroup.id = groupRows[i].id;
        userGroup.name = groupRows[i].name;
        if (groupRows[i].authTag == 1) {
          userGroup.disabled = false;
        } else {
          userGroup.disabled = true;
        }
        this.userGroupLists.push(userGroup);
      }
    },
    getUserLoginId(userId) {
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].value == userId) {
          return this.list[i].label;
        }
      }
    },
    getUserId(loginId) {
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].label == loginId) {
          return this.list[i].value;
        }
      }
    },
    getStatusIdByName(statusName) {
      for (var i = 0; i < this.statusInfoAll.length; i++) {
        if (this.statusInfoAll[i].name == statusName) {
          return this.statusInfoAll[i].id;
        }
      }
    },
    goToState(command) {
      //console.log(this.statusInfo);
      //console.log(command);
      this.title_nextStatusId = command;
      //console.log(this.title_nextStatusId);
      if (this.statusInfo.length != 0) {
        var lists = this.statusInfo;
        for (var i = 0; i < lists.length; i++) {
          if (command == lists[i].id) {
            this.nextStatusText = lists[i].name;
          }
        }
      }
      for (var i = 0; i < this.statusInfo.length; i++) {
        if (command == this.statusInfo[i].id) {
          this.title_nextStatusType = this.statusInfo[i].statusType;
        }
      }
      this.getAudit();
      //console.log(command);
    },
    statusClick() { },
    nextStatusBtnClick() {
      // console.log(this.title_nextStatusType);
      // console.log(this.title_nextStatusId);
      // console.log(this.statusInfo);

      let isHold = 1;
      let nextStatusList = this.title_nextStatusId;
      for (var j = 0; j < this.statusInfo.length; j++) {
        if (this.statusInfo[j].id == nextStatusList) {
          isHold = this.statusInfo[j].statusType;
        }
      }
      if (
        this.title_nextStatusType == 2 ||
        this.title_nextStatusType == 3 ||
        isHold == 2 ||
        isHold == 3
      ) {
        this.audit_dialog = false;
        this.audit_add = true;
      } else {
        this.mandatoryField = false;
        this.statusChange();
      }
      // this.audit_dialog = false;
      // this.audit_add = true;
    },
    tabClick(res, index) {
      // let obj = changeTabList.find((i) => {
      //   return i.id == res.id;
      // });
      this.$store.commit("setTabID", { index, ...this.objInfo });
      const item = this.tabList[index]
      let query = { ...this.$store.state.objectId };
      if (item.id == 1010403) {
        Object.assign(query, { workflowId: Number(this.title_workflowId), currentStatusId: Number(this.title_currentStatusId), })
      }
      this.tabItem = item;

      this.$router.push({ path: item.path, query });
      this.$store.commit('setTabIndex', { ...this.objInfo, index })

    },
    getTab() {
      this.$http.get("/pmdm/admin/getTab/" + this.$store.state.objectId.subClassId).then(res => {
        this.tabList = res.data.object.tabs.map(i => {
          i.path = changeTabList.find(j => j.id == i.id).path
          return i;
        })

        const tabIndex = getTabIndex({ ...this.$store.state.objectId })?.index || 0
        this.tabClick(changeTabList.find(j => j.id == this.tabList[tabIndex].id), tabIndex)

        this.tabIdLists = Array.from(this.tabList, ({ id }) => id);
        this.$getTabsIsUsedResult(this.tabIdLists).then(
          res => {
            this.tabList.map(item => {
              // item.isResult = res.indexOf(item.id) != -1 ? true:false;
              const isTrue = res.includes(item.id)
              this.$set(item, 'isResult', isTrue);
            });
          }
        );
      })
    },
    async logoInfo() {
      //console.log("changePage.logoInfo()");

      var obj_get = {
        //获取change
        ... this.$store.state.objectId,
        tableId: 1,
      };
      console.log(obj_get);
      var loadTableUrl = `/pmdm/changes/loadTable${this.params(obj_get)}`;
      const {
        //获取标题
        data: res2,
      } = await this.$http.get(loadTableUrl);
      if (res2.code !== 200) {
        return this.$message.error(res.message);
      }
      // console.log(res2);
      this.projectWorkflowSubClassId = res2.object.table.rows[0].objSubClass;
      this.loading = true;
      this.page_one = this.getNewData(res2.object.table.columnInfo);
      var val_ = res2.object.table.rows[0].cells;
      //console.log(this.page_one);
      //console.log(val_);
      for (var i = 0; i < this.page_one.length; i++) {
        this.page_one[i].val = val_[i];
        if (this.page_one[i].id == 1004001) {
          this.title_number = this.page_one[i].val.val;
          // this.updateTabName(this.title_number);
        }
        if (this.page_one[i].id == 1004002) {
          this.title_currentStatus = this.page_one[i].val.val;
          this.title_currentStatusId = this.page_one[i].val.id;
          //console.log(this.title_currentStatusId);
          if (this.page_one[i].val.id == -1) {
            this.StatusBtn = true;
          } else {
            this.StatusBtn = false;
          }
        }
        if (this.page_one[i].id == 1004005) {
          this.title_description = this.page_one[i].val.val;
        }
        if (this.page_one[i].id == 1004003) {
          this.title_subClass = this.page_one[i].val.val;
        }
        if (this.page_one[i].id == 1004008) {
          this.title_workflowId = this.page_one[i].val.id;
        }
      }
      // if (this.$store.state.tabId == undefined) {
      //   this.num = 0;
      // } else {
      //   this.num = this.$store.state.tabId;
      // }

      let description_ = "";
      if (this.title_description) {
        description_ = ":" + this.title_description;
      }
      //添加最近访问
      this.addRecentVistInCommon({
        baseClassId: this.Constants.changeBaseClassId,
        number: this.title_number,
        ... this.$store.state.objectId,
        //id: this.$store.state.objId_,
      });

      this.updateFavoriteInCommon({
        baseClassId: this.Constants.changeBaseClassId,
        number: this.title_number,
        ... this.$store.state.objectId,
        //id: this.$store.state.objId_,
      });
      // console.log(this.title_currentStatusId);
      var statusId = this.title_currentStatusId;
      if (statusId === "") statusId = -1;

      var getNextAllStatus = {
        //获取change
        statusId: statusId,
        subClassId: this.$store.state.objectId.subClassId,
      };
      // console.log(getNextAllStatus);
      const getAllStatusUrl = `/pmdm/admin/workflow/getNextStatus${this.params(
        getNextAllStatus
      )}`;
      const { data: res3 } = await this.$http.get(getAllStatusUrl);
      console.log(res3);
      this.currentStatusType = !res3.object.currentWorkflowStatus
        ? 0
        : res3.object.currentWorkflowStatus.statusType;

      let workFlowStatus_ = res3.object.currentWorkflowStatus;
      if (workFlowStatus_) {//提交变更工作流状态
        this.$store.commit("setChangeWorkflowStatus", workFlowStatus_.statusType);
      } else {
        this.$store.commit("setChangeWorkflowStatus", -1);
      };
      if (res3.code == 200) {

        if (res3.object.nextWorkflowStatusType < 0) {
          this.StatusBtn = true;
        } else {
          this.StatusBtn = false;
        }
        if (res3.object.nextStatus.length !== 0) {
          this.statusInfo = res3.object.nextStatus;
          let titleCurrent = res3.object.currentWorkflowStatus.statusType;
          this.title_currentStatusType = titleCurrent;

          switch (titleCurrent) {
            case 0:
              this.currentStatusColorType = "#99ccff";
              break;
            case 1:
              this.currentStatusColorType = "#ffcc33";
              break;
            case 2:
              this.currentStatusColorType = "#cc99cc";
              break;
            case 3:
              this.currentStatusColorType = "#ff6666";
              break;
            case 4:
              this.currentStatusColorType = "#cc3333";
              break;
            case 5:
              this.currentStatusColorType = "#999966";
              break;
            case 6:
              this.currentStatusColorType = "#669933";
              break;
          };

          this.title_nextStatusId = res3.object.nextWorkflowStatus.id;
          this.title_nextStatusType = res3.object.nextWorkflowStatusType;


          this.nextStatusType_old = this.deepClone(
            res3.object.nextWorkflowStatusType
          );

          this.nextStatusTextVal = res3.object.nextStatus[0].name;
          this.nextStatusText = res3.object.nextStatus[0].name;
        } else {
          this.statusInfo = [];
        };
        this.change_to_child = res3.object.currentWorkflowStatus?.id;
        //console.log(this.change_to_child);
      }

      var statusId = this.title_currentStatusId;
      if (statusId === "") {
        statusId = -1;
      }

      var getSignoffUserRequest = {
        //post更改的值
        objectId: {
          ... this.$store.state.objectId,
        },
        status: Number(statusId),
      };

      var session = window.sessionStorage.getItem("userContext");
      session = JSON.parse(session);
      //console.log(session);
      this.currentUserId = session.id;
      this.currentUserLoginId = session.loginId;

      let obj2_get = {
        ... this.$store.state.objectId,
      }
      var loadTableUrl = `/pmdm/changes/checkUsrHasARPriv${this.params(obj2_get)}`;
      const {
        //获取标题
        data: res4,
      } = await this.$http.get(loadTableUrl);
      console.log(res4);
      this.hasARPriv = res4.object.hasPriv == 0;
    },
    verifyExportXml() {
      let obj = {
        ...this.$store.state.objectId,
        changeSubClassId: this.$store.state.objectId.subClassId,
        changeId: this.$store.state.objectId.id,
        changeClassId: this.$store.state.objectId.classId,
      };
      console.log("verifyExportXml");
      if (this.currentStatusType == 3 || this.currentStatusType == 4) {
        axios
          .get(`/pmdm/change/verifyExportXML${this.params(obj)}`)
          .then((res) => {
            console.log(res);
            this.exportEnabled = res.data.object;
          });
      }
    },

    handleCommand(command) {
      if (command == "V1/4" || command == "V1") {
        this.BomData = this.BomData2;
      } else {
        this.BomData = this.BomData1;
      }
    },

    loadUserPriv() {

      const isSuperAdmin = this.$store.state.isSuperAdmin;
      console.log(this.getUserContextPriv(), this.objInfo.subClassId);

      const privList = this.getUserContextPriv()
        .filter(i => i.classId == this.objInfo.subClassId)
        .map(j => j.type);
      // console.log(privList);

      this.addApproverPriv = isSuperAdmin || privList.includes(0) || privList.includes(19);
      // this.deletePriv = isSuperAdmin || privList.includes(25);

      const hasDel = this.getUserContextPriv().map(j => j.type).includes(25)

      this.deletePriv = isSuperAdmin || hasDel;
      this.rebackPriv = isSuperAdmin || privList.includes(32);
    },

  },
  components: {
    searchAddUsers,
    SaveAsForm
  },
  watch: {
    currentStatusType: function (value) {
      this.verifyExportXml();
    },
  },
  mounted() {
    this.isDocRelease = this.$store.state.objectId.subClassId == 9020181;
  },
  created() {

    let tenantName = window.sessionStorage.systemName;
    this.thondarYON = tenantName.indexOf("Thondar") != -1
    //console.log("changePage.created()");
    const { id, classId, subClassId } = this.$route.query;
    const obj = { id, classId, subClassId };
    this.$store.commit('setObjectId', obj);

    this.userInfo = this.$store.state.userInfo;
    //console.log(this.userInfo);
    this.logoInfo().then(res => {
      this.getTab();
    }).then(this.verifyExportXml);
    this.loadUserPriv();
    this.getWorkflow();

  },
};
</script>
<style scoped>
.route-content {
  padding: 10px 15px;
  height: calc(100vh - 350px);
  overflow-y: scroll;
}
</style>

<style>
.reviewersAddDialog .el-dialog__body {
  padding: 0 20px 20px 20px !important;
}

.notifyAddDialog .el-dialog__body {
  padding: 0 20px 20px 20px !important;
}

.audit .el-dialog__body {
  padding: 0 !important;
}

.next-status-btn .el-button-group button:first-child {
  color: #c0c4cc;
  cursor: not-allowed;
}
</style>

<style scoped>
.workflow-dialog ::v-deep .el-dialog__header {
  padding: 0;
}

.workflow-box {
  padding: 16px;
  background-color: #f3f3f3;
}

.workflow-box .workflow-title {
  font-size: 16px;
}

.workflow-content {
  padding: 16px;
}

.error-list div,
.warning-list div {
  font-size: 16px
}

.error-list ul,
.warning-list ul {
  list-style: disc
}

.error-list li,
.warning-list li {
  font-size: 14px;
  margin: 10px 20px
}

.warning-list li {
  color: #f7a420
}

.error-list li {
  color: red
}


.content-title {
  height: 45px;
  display: flex;
  gap: 20px;
  padding-left: 20px;
  margin-top: 8px;

  .content-item {
    padding: 8px 15px;
    font-size: 16px;
    cursor: pointer;

    &:hover {
      border-bottom: 3px solid #4b92ff;
      color: #4b92ff;
    }

    &.active {
      border-bottom: 3px solid #4b92ff;
      color: #4b92ff;
    }
  }


}



.tableBtn {
  position: absolute;
  bottom: 0;
  right: 0;

}

.table-list2 {
  overflow: auto;
  margin-top: 4px;
}

.table-list2 .list-key {
  display: inline-block;
  width: 22%;
  text-align: right;
  font-size: 14px;
  line-height: 40px;
  float: left;
}

.table-list2 .list-val {
  display: inline-block;
  width: 60%;
  overflow: hidden;
}

.title-current-style {
  font-size: 28px;
  position: absolute;
  right: 18%;
  top: 10%;
  padding: 10px;
  border-radius: 4px;
}
</style>